import { Icon, Stack, Typography } from '@mui/material';
import YesNoDialog from 'common/components/YesNoDialog';
import useFlexBoxStyles from 'common/flexBox';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    list: {
        marginTop: theme.spacing(1),
        maxHeight: theme.spacing(40),
        overflowY: 'auto',
    },
    item: {
        padding: theme.spacing(1, 0),
    },
    icon: {
        fontSize: '18px',
        padding: '5px',
        borderRadius: '100%',
        color: '#fff',
        background: 'rgba(237, 108, 2, 0.9)',
        fontFamily: 'Material Icons',
    },
}));

/**
 * Confirmation dialog shown before saving a service when the preview-issues
 * endpoint reports issues that will be generated by the pending changes.
 * Lets the user confirm the save anyway or cancel to keep editing.
 */
const ServicePreviewIssuesDialog = ({ open, issues, allowSave = true, onConfirm, onCancel }) => {
    const { t } = useTranslation();
    const { classes } = useStyles();
    const { classes: flexBox } = useFlexBoxStyles();

    // Same actions in both cases; when saving with issues is not allowed the
    // "save anyway" button is simply disabled.
    return (
        <YesNoDialog
            openDialog={open}
            title={t('services.previewIssues.title')}
            messageToConfirm={
                allowSave ? t('services.previewIssues.message') : t('services.previewIssues.blockedMessage')
            }
            yesButtonText={t('services.previewIssues.saveAnyway')}
            noButtonText={t('app.common.cancel')}
            disableYes={!allowSave}
            yesButtonCallback={onConfirm}
            noButtonCallback={onCancel}
        >
            <Stack direction="column" className={classes.list}>
                {(issues || []).map((issue, idx) => (
                    <Stack
                        key={issue.code || idx}
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        className={classes.item}
                    >
                        <Icon className={classes.icon}>{issue.icon || 'warning'}</Icon>
                        <Typography variant="subtitle2" fontWeight={400} className={flexBox.paddingLeft1}>
                            {issue.title || issue.code}
                        </Typography>
                    </Stack>
                ))}
            </Stack>
        </YesNoDialog>
    );
};

export default ServicePreviewIssuesDialog;
